import Button from '@material-ui/core/Button';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import { trimSpaces } from '../../../../../utils/Util';
import ErrorAwareBankAccountField from '../../../../common/inputfields/ErrorAwareBankAccountField';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import MyCreatableAutocomplete from '../../../../common/inputfields/MyAutocomplete';
import NewAgainField from '../../../../common/inputfields/NewAgainField';

class NewRestrainPartner extends Component {

    state = {
        newAgain: false,
        selectedEmployee: {},
        name: '',
        comment: '',
        bankAccountNumber: '',
        errors: new Map(),
    }

    resetForm = () => {
        this.setState({
            newAgain: false,
            selectedEmployee: {},
            name: '',
            comment: '',
            errors: new Map(),
        })
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/restrainpartner';
        const requestObject = {
            "employeeId": this.state.selectedEmployee.value,
            "name": this.state.name,
            "comment": this.state.comment,
            "bankAccountNumber": trimSpaces(this.state.bankAccountNumber),
        };
        handlePost(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            type: 'FULL_TIME'
        };
        const response = await axios.get('/api/employees', { params })
        const renamedCustomers = [];
        response.data.map((resp) =>
            renamedCustomers.push({
                label: resp.employee.name,
                value: resp.employee.privateId,
                netSalary: resp.employee.netSalary,
                paymentMethod: resp.employee.paymentMethod,
            }));
        return renamedCustomers;
    };

    handleEmployeeSelected = (e, v) => {
        console.log(v);
        let p = enums.getObjectByValue(enums.outPaymentMethods, v.paymentMethod);
        this.setState({ selectedEmployee: v, netSalary: v.netSalary, selectedPaymentMethod: p })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            label={'Munkavállaló'}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="name"
                            label="Partner neve"
                            errors={this.state.errors}
                            value={this.state.name}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareBankAccountField
                            name="bankAccountNumber"
                            label="Bankszámlaszám"
                            errors={this.state.errors}
                            value={this.state.bankAccountNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)}
                        />
                    </div>
                </div>
                <div className="form-actions">
                    <NewAgainField
                        checked={this.state.newAgain}
                        onChange={e => this.setState({ newAgain: e.target.checked })} />
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Hozzáadás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(NewRestrainPartner);
